import { get } from 'lodash';
import ApiCaller from './ApiCaller';
import baseAjaxConfig from './BaseAjaxConfig';
//TODO: Move all the autoSuggestion actions in this file (includes helpcenter search and search bar suggestion actions)
export const AUTO_SUGGESTION_REQUEST = 'AUTO_SUGGESTION_REQUEST';
export const AUTO_SUGGESTION_SUCCESS = 'AUTO_SUGGESTION_SUCCESS';
export const AUTO_SUGGESTION_ERROR = 'AUTO_SUGGESTION_ERROR';
export const RESET_AUTO_SUGGESTION = 'RESET_AUTO_SUGGESTION';
export function resetSuggestionAction(suggestionType = 'TYPE_ADDRESS_LINE2') {
    return (dispatch) => dispatch({
        type: RESET_AUTO_SUGGESTION,
        suggestionType
    });
}
export function fetchSuggestionAction(text, suggestionType = 'TYPE_ADDRESS_LINE2') {
    return (dispatch, getState) => {
        dispatch({
            type: AUTO_SUGGESTION_REQUEST,
            suggestionType
        });
        const regionTypeFilters = get(getState(), ['pincodeData', 'regionFilters'], {});
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/1/address/suggest',
            action: AUTO_SUGGESTION_REQUEST
        }), {
            count: 4,
            enteredText: text,
            inputFieldType: suggestionType,
            regionTypeFilters: suggestionType === 'TYPE_CITY' ? {} : regionTypeFilters
        })
            .then(json => dispatch({
            type: AUTO_SUGGESTION_SUCCESS,
            suggestionType,
            data: json['RESPONSE']
        }))
            .catch(error => {
            return dispatch({
                type: AUTO_SUGGESTION_ERROR,
                suggestionType,
                error
            });
        });
    };
}
